import {
  CreditCard as CreditCardIcon,
  CreditCardSlash as CreditCardSlashIcon,
  PharmacyCrossTag as PharmacyCrossTagIcon,
} from 'iconoir-react'
import { ReactElement } from 'react'

/**
 * The glyph for a ledger transaction type.
 *
 * One definition because it now appears in three places: the transaction card,
 * a collapsed run of them, and the Ledger's filter chips. A payment that is
 * emerald on the card and something else on the chip that reveals it would be
 * actively misleading.
 *
 * The type is a free-text string from each practice's own vocabulary, so
 * anything unrecognised renders nothing rather than guessing.
 */
export function TransactionTypeIcon({
  type,
  className = `h-5 w-5 shrink-0 rounded-md p-1 text-on-color`,
}: {
  type: string | null | undefined
  className?: string
}): ReactElement {
  switch (type?.toLowerCase()) {
    case `procedure`:
      return <PharmacyCrossTagIcon className={`${className} bg-violet-600`} />
    case `payment`:
      return <CreditCardIcon className={`${className} bg-emerald-600`} />
    case `adjustment`:
      return <CreditCardSlashIcon className={`${className} bg-cyan-600`} />
    default:
      return <></>
  }
}
